import { render, staticRenderFns } from "./Socios.vue?vue&type=template&id=ec24ce0e&scoped=true"
import script from "./Socios.vue?vue&type=script&lang=js"
export * from "./Socios.vue?vue&type=script&lang=js"
import style0 from "./Socios.vue?vue&type=style&index=0&id=ec24ce0e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec24ce0e",
  null
  
)

export default component.exports